import React from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';

import { Footer } from './Footer';
import { MainHeader } from './MainHeader';
import Snackbar from './Snackbar';
import { IUser } from '../types/User';
import { connect } from 'react-redux';
import { setLanguage } from '../store/reducers/user/actions';
import { useLocation } from 'react-router-dom';
import CookieBanner from './CookieBanner';
import useWindowDimensions from '../hooks/useWindowDimensions';
import BannedPopup from './popup/Banned';

const DivWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  input:required:focus:invalid {
    border-color: #c30b30;
  }
`;
const DivContent = styled.main`
  padding-bottom: 296px;
  background-color: ${props => (props.white ? '#fff' : '#F2F2F2')};
  min-height: calc(100vh - 296px);
  @media (min-width: 1200px) {
    ${props =>
      props.pb &&
      css`
        padding-bottom: ${props.pb};
      `}
  }
`;
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background-color: #fff;
    font-family: 'Lato', sans-serif;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    padding: 0;
    margin: 0;
  }`;

interface PageLayoutProps {
  children: React.ReactNode;
  user: IUser;
  cart: any;
  white?: boolean;
  noFooter?: boolean;
  setLanguage: (payload: any) => void;
  pb?: string;
}

const PageLayout = ({ children, user, cart, setLanguage, pb = '', _noFooter = false }: PageLayoutProps) => {
  const { width } = useWindowDimensions();

  const { pathname } = useLocation();

  const white = pathname.includes('cart') || pathname.includes('register');
  return (
    <DivWrapper>
      <GlobalStyle />
      <MainHeader cart={cart} user={user} isMobile={width <= 768} setLanguage={setLanguage} />
      <DivContent pb={pb} white={white}>
        {children}
      </DivContent>
      <CookieBanner />
      {/* {!noFooter && <Footer />} */}
      <Footer locale={user.locale} isCartPage={pathname.includes('cart')} />
      <Snackbar />
      <BannedPopup />
    </DivWrapper>
  );
};

const mapStateToProps = ({ user: { user }, cart }: any) => ({ user, cart });
const mapDispatchToProps = {
  setLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout);
